<template>
  <AppRadioGroup
    v-model="status"
    :label="$tt('marital_status')"
    :rules="[required]"
    :inline="!mobile"
    class="radio"
  >
    <AppRadio v-for="(label, value) in statuses" :key="value" :value :label />
  </AppRadioGroup>
</template>

<script setup lang="ts">
import type { MaritalStatus } from '~/types';

const { tt } = useLocalization();

const statuses: Record<MaritalStatus, string> = {
  single: tt('marital.single'),
  married: tt('marital.married'),
  divorced: tt('marital.divorced'),
  widowed: tt('marital.widowed'),
};

const status = defineModel<MaritalStatus>({ required: true });

const { required } = useValidation();
const { mobile } = useBreakpoints();
</script>